export const config = {
	defaultLanguage: 'pl',
	availableLanguages: ['pl', 'en'],
}
